import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.urlAfterRedirects;
    });
  }

  createUrl(route: string, queryParams?: Record<string, any>): string {
    const urlTree = this.router.createUrlTree([route], { queryParams });
    return `${window.location.origin}${this.router.serializeUrl(urlTree)}`;
  }

  navigateTo(route: string, queryParams?: Record<string, any>, target: '_self' | '_blank' = '_self'): void {
    if (target === '_blank') {
      const url = this.createUrl(route, queryParams);
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      this.router.navigate([route], { queryParams });
    }
  }

  handleNavigation(event: MouseEvent, route: string, queryParams?: Record<string, any>): void {
    if (event.button === 1 || event.ctrlKey || event.metaKey) {
      return;
    }

    if (event.button === 0) {
      event.preventDefault();
      this.navigateTo(route, queryParams, '_self');
    }
  }
}